import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query bondControlWithPagination($page: Int, $perPage: Int, $filters: FiltersBondControlList) {
  bondControlWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      bond_type_id
      bondType {
        id
        name
      }
      amount
      observations
      fortnight
      year
      month
      abstents_first_week
      abstents_second_week
      headquarter_id
      area_id
      sub_area_id
    }
  }
}
`

const GET_ALL = gql`
  query bondControls ($filters: FiltersBondControl) {
    bondControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      bond_type_id
      bondType {
        id
        name
      }
      amount
      observations
      fortnight
      year
      month
      abstents_first_week
      abstents_second_week
      is_active
      status_text
    }
  }
`

export const GENERATE = gql`
  query bondControlGenerate($filters: FiltersBondControl!) {
    bondControlGenerate(filters: $filters) {
      employee_id
      employee {
        id
        email
        name
        last_name
        mothers_last_name
        fullName
        fullLastName
        document_type
        document_number
        phone_number
      }
      observations
      abstents_first_week
      abstents_second_week
      bond_controls {
        bond_type_id
        amount
      }
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createBondControl ($input: BondControlForm!) {
    createBondControl (input: $input) {
      id
      employee_id
    }
  }
`

const UPDATE = gql`
  mutation updateBondControl ($id: ID!, $input: BondControlForm!) {
    updateBondControl (id: $id, input: $input) {
      id
      employee_id
      amount
    }
  }
`

export const LOAD_MASSIVE = gql`
  mutation saveBondControls($input: [BondControlForm!]!) {
    saveBondControls(input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deleteBondControl ($id: ID!) {
    deleteBondControl(id: $id) { 
      id
    }
  }
`

export const GET_BOND_CONTROL_MASSIVE_WITH_PAGINATION = gql`
  query bondControlMassiveWithPagination ($first: Int!, $page: Int!, $filters: FiltersBondControlList) {
	  bondControlMassiveWithPagination(first: $first, page: $page, filters: $filters) {
      pagination {
        count
        currentPage
        perPage
        total
      },
      data {
        headquarter_id
        headquarter {
          name
        }
        area_id
        area {
          name
        }
        sub_area_id
        sub_area {
          name
        }
        year
        month
        fortnight
        bondType {
          name
          id
        }
        bond_type_id
      }
    }
  }
`

export const DELETE_MASSIVE = gql`
 mutation deleteBondControlMassive ($headquarter: ID!, $area: ID!, $sub_area: ID!, $year: Int!, $month: Int!, $fortnight: Int!, $loaded_massive: Boolean!) {
  deleteBondControlMassive(headquarter: $headquarter, area: $area, sub_area: $sub_area, year: $year, month: $month, fortnight: $fortnight, loaded_massive: $loaded_massive) {
    success
  }
 }
`

export {
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL
}
